import React from 'react';
import './PostTypeIndicator.css';

const PostTypeIndicator = ({ post, platform, isQuotePost, quotedPostId, isRepostProp, repostedPostId }) => {
  if (!post && !isQuotePost && !isRepostProp) return null;

  // Check if it's a quote by checking if any quote ID exists (no boolean flag needed)
  const quoteId = post?.quoted_post_id || post?.quoted_post || post?.quote_tweet_id || quotedPostId;
  const isQuote = !!quoteId || isQuotePost;
  
  // Check if it's a repost/retweet by checking if any repost ID exists (no boolean flag needed)
  const repostId = post?.reposted_post_id || post?.reposted_post || post?.retweet_id || repostedPostId;
  const isRepost = !!repostId || isRepostProp;

  if (!isQuote && !isRepost) {
    return null;
  }

  const getIndicator = () => {
    // Quote indicators
    if (isQuote && quoteId) {
      const isTwitter = platform === 'twitter' || platform === 'x';
      return (
        <div className="post-type-indicator quote-indicator">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>{isTwitter ? 'Quote tweet' : 'Quoted post'}</span>
        </div>
      );
    } 
    // Repost/Retweet indicators
    else if (isRepost && repostId) {
      const isTwitter = platform === 'twitter' || platform === 'x';
      return (
        <div className="post-type-indicator repost-indicator">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="16 6 12 2 8 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="12" y1="2" x2="12" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <span>{isTwitter ? 'Retweet' : 'Reposted'}</span>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="post-type-indicators">
      {getIndicator()}
    </div>
  );
};

export default PostTypeIndicator;